//angular
import { Component, Inject, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconRegistry } from "@angular/material/icon";
//app
import { AppAnimations } from 'src/app/_shared/animations';
import { LoaderService } from 'src/app/_core/services';
import { PickupInStoreComponent } from '../../../../store-setup/shipping/shipping-settings/pickup-in-store/pickup-in-store.component';
import { FormControl, Validators } from '@angular/forms';

@Component({
  animations: [AppAnimations],
  selector: 'send-test-dialog.component',
  templateUrl: './send-test-dialog.component.html',
})

export class SendTestDialogComponent {
  emailFormControl = new FormControl(null, [Validators.required, Validators.email]);
  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    private _dialogRef: MatDialogRef<SendTestDialogComponent>,
    private _iconRegistry: MatIconRegistry,
    private _loader: LoaderService,
    private _sanitizer: DomSanitizer,
  ) {
    this._iconRegistry.addSvgIcon('ico-close', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-01.svg'));
  }

  onClose(): void {
    this._dialogRef.close();
  }

  onSubmit() {
      this._dialogRef.close(this.emailFormControl.value);
  }

}
